<template>
  <v-card
    width="400"
    elevation="24"
  >
    <v-row
      align="center"
      justify="center"
      style="height: 100%"
    >
      <v-col>
        <v-row
          align="center"
          justify="center"
          class="ma-5"
          id="login-header"
        >
          <h1> Forgot Password </h1>
        </v-row>
        <v-row
          align="center"
          justify="center"
        >
          <v-col>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="email"
                  color="orange"
                  class="login-form-element"
                  label="Email Address"
                  rounded
                  solo
                  prepend-inner-icon="mdi-email"
                  @keydown.enter="validateLogin"
                  :rules="[authorizedMessage]"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-btn
                  height="50px"
                  class="login-form-element"
                  color="rgb(255, 149, 24)"
                  rounded
                  @click="sendResetLink"
                >
                  Send Password Reset Link
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LoginCard',

  data: () => ({
    email: '',
    valid: false,

    // whether the client is authorized to enter
    authorized: false,

    // whether the form helper messages should be displayed
    authorizedMessage: true
  }),

  methods: {
    ...mapActions(['requestPasswordResetLink']),

    async sendResetLink () {
      const response = await this.requestPasswordResetLink(this.email)
      this.$emit('password-reset-response', response)

      if (response.success) {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  #login-header
    top: -10px

  .login-form-element
    width: 75%
    max-width: 75%
</style>
